import * as React from "react";
import { PatientType } from "api/patientApi";
import CustomModal from "../common/CustomModal";
import Button from "@mui/joy/Button";
import { theme } from "../../styles/theme";
import useEnableTaskUpdateRequired from "hooks/useEnableTaskUpdateRequired";

export default function PatientTaskUpdateRequiredEnableButton({
  patient,
  onAfterAction,
}: {
  patient: PatientType;
  onAfterAction: () => void;
}) {
  const {
    allowed,
    modalOpen,
    setModalOpen,
    modalTitle,
    modalSubtitle,
    enable,
  } = useEnableTaskUpdateRequired(patient);

  return (
    <>
      <Button
        size="sm"
        variant="Plain"
        color={"neutral"}
        onPointerDown={(e) => e.stopPropagation()}
        onClick={(e) => {
          e.stopPropagation();
          if (!allowed) {
            setModalOpen(true);
            return;
          }
          onAfterAction();
          enable();
        }}
        sx={{
          width: "100%",
          height: "44px",
          fontSize: "14px",
          fontWeight: 500,
          px: "20px",
          justifyContent: "flex-start",
          whiteSpace: "nowrap",
          color: theme.vars.palette.Content.Strong,
          backgroundColor: theme.vars.palette.Surface.Forward,
        }}
      >
        {"업데이트 필요 목록에 넣기"}
      </Button>
      <CustomModal
        open={modalOpen}
        onClose={() => {
          onAfterAction();
          setModalOpen(false);
        }}
        title={modalTitle}
        subtitle={modalSubtitle}
        actions={[
          {
            label: "확인",
            variant: "Solid",
            onClick: () => {
              if (allowed) {
                enable();
              }
              onAfterAction();
              setModalOpen(false);
            },
          },
        ]}
      />
    </>
  );
}
